import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AuthActions } from '@auth/store';
import { SmicActions } from '@features/referentiel/actions/smic.actions';
import { catchError, map, of, switchMap } from 'rxjs';
import { SmicService } from '@features/referentiel/services/smic.service';
import { Smic } from '@shared/models/referentiel/smic';

@Injectable()
export class SmicEffects {
  initSmic$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.userProfileLoaded),
      map(() => SmicActions.getSmic()),
    ),
  );

  loadSmics$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SmicActions.getSmic),
      switchMap(() =>
        this.smicService.getAllSmics().pipe(
          map((data: Smic[]) => SmicActions.getSmicSuccess({ smics: data })),
          catchError((error) => of(SmicActions.getSmicFailure({ errorMessage: error }))),
        ),
      ),
    ),
  );

  constructor(private actions$: Actions, private smicService: SmicService) {}
}
